import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ConfigurationAction } from "stores/Configuration/ConfigurationAction";

const mapStateToProps = (state) => {
  return {
    ConfigurationTableList: state.GlobleConfiguration.ConfigurationTableList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getConfigurationTableAction: ConfigurationAction.getConfigurationTableAction,

}, dispatch);

const ConfigurationStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ConfigurationStore;
 